<template>
  <div>
    <b-row class="justify-content-center mt-2 mb-4">
      <span class="center-title">Place Order</span>
    </b-row>
    <EmptyCart v-if="cartItemsCount == 0" />
    <div v-else>
      <b-row>
        <b-col md="8" lg="8">
          <label class="h4 font-weight-bold d-block">Order Information</label>
          <a href="#" class="d-block mb-2" v-on:click="$router.push({name: 'Cart'})">Back to Order</a>
          <form method="post" ref="checkoutForm" v-on:submit="submitOrder($event)">
            <b-row>
              <b-col class="mb-3" md="6">
                <label for="first_name">First Name*</label>
                <input
                  class="form-control"
                  name="first_name"
                  v-model="checkoutFields.first_name"
                  required
                />
              </b-col>
              <b-col class="mb-3" md="6">
                <label for="last_name">Last Name*</label>
                <input
                  class="form-control"
                  name="last_name"
                  v-model="checkoutFields.last_name"
                  required
                />
              </b-col>

              <b-col class="mb-3" md="6">
                <label for="company">Company Name (Optional)</label>
                <input class="form-control" name="company" v-model="checkoutFields.company" />
              </b-col>
              <b-col class="mb-3" md="6">
                <label for="phone">Telephone Number</label>
                <input class="form-control" name="phone" v-model="checkoutFields.phone" required />
              </b-col>
              <b-col class="mb-3" md="12">
                <label for="email">Email*</label>
                <input
                  class="form-control"
                  type="email"
                  v-model="checkoutFields.email"
                  name="email"
                  required
                />
              </b-col>
              <b-col class="mb-3" md="12">
                <label for="street_address">Address *</label>
                <textarea class="form-control" name="address" v-model="checkoutFields.address"></textarea>
              </b-col>
            </b-row>
            <input type="submit" ref="submitBtn" style="display:none" />
          </form>
        </b-col>
        <OrderSummary :page="1" v-on:place-order="placeOrder" />
      </b-row>
    </div>
  </div>
</template>
<script>
import OrderSummary from "../components/cart-components/OrderSummary";
import { mapGetters } from "vuex";
import EmptyCart from "../components/EmptyCart";

export default {
  name: "Cart",
  components: {
    OrderSummary,
    EmptyCart,
  },
  data() {
    return {
      checkoutFields: {},
    };
  },
  methods: {
    placeOrder: function () {
      this.$refs.submitBtn.click();
    },
    submitOrder: function (event) {
      if (event) event.preventDefault();
      this.$axios
        .post("checkout", {
          fields: this.checkoutFields,
          corporate: this.$store.getters.getCorporateCode,
          products: this.$store.getters.getCartItems,
        })
        .then((res) => {
          if (res.data.type == "success") {
            this.$store.commit("emptyCart");
            this.$router.push({
              name: "OrderRecieved",
              params: { id: res.data.order_id },
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters({
      cartItems: "getCartItems",
      cartItemsCount: "getCartItemsCount",
    }),
  },
};
</script>
